export const ADMIN_OPENED_CASE_KEYS = {
  supportTickets: 'support-tickets',
  appeals: 'appeals',
};

const storageKey = (namespace) => `tp-admin-${namespace}-opened-cases`;

export function getOpenedCaseIds(namespace) {
  try {
    const raw = localStorage.getItem(storageKey(namespace));
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
  } catch {
    return new Set();
  }
}

export function markCaseOpened(namespace, id) {
  if (!id) return;
  const ids = getOpenedCaseIds(namespace);
  const key = String(id);
  if (ids.has(key)) return;
  ids.add(key);
  localStorage.setItem(storageKey(namespace), JSON.stringify([...ids]));
}

/**
 * When a record is opened for the first time, advance its status.
 * Appeals: Submitted (legacy New) → Under Review.
 * Support Tickets / others: New → In Progress.
 */
export function applyOpenedNewToInProgress(namespace, record, idKey) {
  if (!record || !idKey) return record;
  const id = record[idKey];
  if (!id) return record;
  if (!getOpenedCaseIds(namespace).has(String(id))) return record;

  const isAppeals = namespace === ADMIN_OPENED_CASE_KEYS.appeals;
  let status = record.status;

  if (isAppeals) {
    if (status === 'New') status = 'Submitted';
    if (status === 'In Progress') status = 'Under Review';
    if (status !== 'Submitted') {
      return status === record.status ? record : { ...record, status };
    }
    return {
      ...record,
      status: 'Under Review',
      assignedHandler: record.assignedHandler || 'Alex Morgan',
      lastUpdated: new Date(),
    };
  }

  if (status === 'Submitted') status = 'New';
  if (status !== 'New') return record;

  return {
    ...record,
    status: 'In Progress',
    lastUpdated: new Date(),
  };
}

/** Mark opened and return the record with New → In Progress applied when needed. */
export function openCaseAndAdvanceStatus(namespace, record, idKey) {
  if (!record || !idKey) return record;
  markCaseOpened(namespace, record[idKey]);
  return applyOpenedNewToInProgress(namespace, record, idKey);
}
